module.exports = __webpack_public_path__ + "img/shape_round.ab4ccfc6.png";